module.exports = new __parcel__URL__("meteor.84d2c398.png").toString();